export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Appliance repair technicians, independent repairers, service technicians, maintenance technicians, appliance repair trainees, and professionals working with household appliances.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. HOME APPLIANCE DIAGNOSTIC PRO™ is a 100% digital resource.',
  },
  {
    question: 'Is this a training course or certification?',
    answer: 'No. It is a visual diagnostic and professional reference system.',
  },
  {
    question: 'Is it another theory-heavy ebook?',
    answer:
      'No. It focuses on organized visual references, symptom-based troubleshooting, component checks, testing references, diagnostic workflows, and structured fault isolation.',
  },
  {
    question: 'What areas are included?',
    answer:
      'Electrical testing, appliance components, refrigerators, freezers, washing machines, dryers, dishwashers, ovens, ranges, common symptoms, component testing, and structured fault-finding.',
  },
  {
    question: 'Does this replace manufacturer service information?',
    answer:
      'No. It is a diagnostic reference resource and does not replace manufacturer service manuals, model-specific specifications, electrical safety procedures, technical training, or professional judgment.',
  },
  {
    question: 'How will I receive it?',
    answer: "You'll receive immediate digital access after purchase.",
  },
  {
    question: 'Does it work for any appliance brand or model?',
    answer:
      'The system is organized by appliance, symptom and component, so the diagnostic logic applies across brands and models. Specific values, wiring and procedures must always be confirmed against the manufacturer service information for the appliance you are working on.',
  },
  {
    question: 'Do I need special tools to use it?',
    answer:
      'No special equipment is required. The references are built around common service tools such as a multimeter, clamp meter and basic hand tools, and show you what to check, what to test and how to interpret the results.',
  },
  {
    question: 'Can I use it on a phone or tablet during service calls?',
    answer:
      "Yes. It is a digital resource you can open on a phone, tablet, laptop or desktop, so the diagnostic references stay with you at the customer's appliance while you work.",
  },
]
